import { FC, SVGProps } from 'react';

const TrainingVideoIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#fff',
  size = 24,
  ...props
}) => (
  <svg
    fill={color}
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    viewBox="0 0 32 32"
  >
    <g filter="url(#filter0_b_8232_1002)">
      <rect width={32} height={32} rx={16} fill="black" fillOpacity={0.1} />
      <rect width={32} height={32} rx={16} fill="black" fillOpacity={0.2} />
      <path
        d="M14.1998 20.9998L20.6998 16.8332C21.0109 16.6332 21.1665 16.3554 21.1665 15.9998C21.1665 15.6443 21.0109 15.3665 20.6998 15.1665L14.1998 10.9998C13.8665 10.7776 13.5276 10.7609 13.1832 10.9498C12.8387 11.1387 12.6665 11.4332 12.6665 11.8332V20.1665C12.6665 20.5665 12.8387 20.8609 13.1832 21.0498C13.5276 21.2387 13.8665 21.2221 14.1998 20.9998ZM15.9998 29.3332C14.1554 29.3332 12.4221 28.9832 10.7998 28.2832C9.17761 27.5832 7.7665 26.6332 6.5665 25.4332C5.3665 24.2332 4.4165 22.8221 3.7165 21.1998C3.0165 19.5776 2.6665 17.8443 2.6665 15.9998C2.6665 14.1554 3.0165 12.4221 3.7165 10.7998C4.4165 9.17761 5.3665 7.7665 6.5665 6.5665C7.7665 5.3665 9.17761 4.4165 10.7998 3.7165C12.4221 3.0165 14.1554 2.6665 15.9998 2.6665C17.8443 2.6665 19.5776 3.0165 21.1998 3.7165C22.8221 4.4165 24.2332 5.3665 25.4332 6.5665C26.6332 7.7665 27.5832 9.17761 28.2832 10.7998C28.9832 12.4221 29.3332 14.1554 29.3332 15.9998C29.3332 17.8443 28.9832 19.5776 28.2832 21.1998C27.5832 22.8221 26.6332 24.2332 25.4332 25.4332C24.2332 26.6332 22.8221 27.5832 21.1998 28.2832C19.5776 28.9832 17.8443 29.3332 15.9998 29.3332Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_8232_1002"
        x={-20}
        y={-20}
        width={72}
        height={72}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation={10} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_8232_1002"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_8232_1002"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default TrainingVideoIcon;
